import React from 'react'
import * as Styled from './TextArea.styles'
import { TextAreaProps as ComponentProps } from './TextualFormElement.types'

const TextArea: React.FC<ComponentProps> = React.forwardRef<HTMLTextAreaElement, ComponentProps>((props, ref) => {
  const { disabled, isError, size = 'large', onChange, onValueChange, className, resize = 'none', ...otherProps } = props

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(event)
    }
    if (onValueChange) {
      onValueChange(event.currentTarget.value)
    }
  }

  return (
    <Styled.Container isError={isError} size={size} isDisabled={disabled} className={className}>
      <Styled.TextArea as="textarea" onChange={handleChange} disabled={disabled} resize={resize} ref={ref} {...otherProps} />
    </Styled.Container>
  )
})

TextArea.displayName = 'TextArea'
export default TextArea
